module.exports = __webpack_public_path__ + "img/zh-cn_get.2617812.png";